import styles from "./spacing.module.scss";

type Props = {
  /**
   * The size of the spacing, can be 1, 2, 3, or 4.
   */
  size?: 1 | 2 | 3 | 4;
};

export const SpacingUI = ({ size = 3 }: Props) => (
  <div data-testid="spacing" className={styles[`spacing-${size}`]}></div>
);
